<div
  id="root-container"
  class="bg-white rounded-mib not-expanded:w-dvw not-expanded:rounded-b-none p-2 transform ease-in-out"
  [class]="transitionClasses()">
  <ul>
    @for (example of promptExamples(); track example.prompt) {
      <li
        class="flex gap-3 px-3 py-2 items-center rounded-mib transition-colors hover:bg-gray-100 active:bg-gray-200 cursor-pointer"
        (click)="selectPrompt(example)">
        <div
          class="shrink-0 h-8 w-8 rounded-mib text-mib-branding-900 bg-mib-branding-50 flex items-center justify-center">
          <mai-prompt-example-icon [type]="example.icon"></mai-prompt-example-icon>
        </div>
        {{ example.title }}
      </li>
    }
  </ul>
</div>
